import { render } from "./ProfileFollowerContent.vue?vue&type=template&id=be14639c&scoped=true"
import script from "./ProfileFollowerContent.vue?vue&type=script&lang=js"
export * from "./ProfileFollowerContent.vue?vue&type=script&lang=js"

import "./ProfileFollowerContent.vue?vue&type=style&index=0&id=be14639c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be14639c"]])

export default __exports__